import {Component, OnDestroy, OnInit} from "@angular/core";
import {SessionActions} from "../../shared/actions/session.actions";
import {select} from "@angular-redux/store";
import {FormControl, Validators} from "@angular/forms";
import {Subscription} from "rxjs/Subscription";
import {AdminUnitActions} from "../../shared/actions/admin-unit.actions";

@Component({
  selector: 'vb-user-menu-item',
  templateUrl: './user-menu-item.component.html',
  styleUrls: ['./user-menu-item.component.css']
})
export class UserMenuItemComponent implements OnInit, OnDestroy {

  @select(['session', 'loggedIn']) loggedIn$;
  @select(['session', 'user']) currentUser$;

  adminUnitCtrl: FormControl = new FormControl(null, Validators.required);
  adminUnitCtrlSub: Subscription;

  constructor(private sessionActions: SessionActions, private adminUnitActions: AdminUnitActions) {
  }

  ngOnInit() {
    this.adminUnitCtrlSub = this.adminUnitCtrl.valueChanges.subscribe((adminUnit: any) => {
      if (adminUnit) {
        this.adminUnitActions.selectAdminUnit(adminUnit);
      }
    });
  }

  ngOnDestroy(): void {
    if (this.adminUnitCtrlSub) {
      this.adminUnitCtrlSub.unsubscribe();
    }
  }

  onLogout() {
    this.sessionActions.logoutUser();
  }

}



// WEBPACK FOOTER //
// ./src/app/navigation/user-menu-item/user-menu-item.component.ts